//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import Images from '@/scripts/libs/images'

export default {
  name: 'RbProductTileVariantsCarousel',
  inject: ['isLoading', 'isPlpExclusive'],
  props: {
    variants: {
      type: Array,
      required: true,
    },
    isTransition: {
      type: Boolean,
      default: false,
    },
    transitionImage: {
      type: String,
      default: '',
    },
    isFirstTransitionInViewport: {
      type: Boolean,
      default: false,
    },
    isWornImage: {
      type: String,
      default: '',
    },
    isInsideSearchPanel: {
      type: Boolean,
      default: false,
    },
    showHoverImage: {
      type: Boolean,
      default: false,
    },
    firstHover: {
      type: Boolean,
      default: false,
    },
    selectedVariantIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isFirstShow: false,
      transitionLoaded: false,
    }
  },
  computed: {
    showTransition() {
      if (!this.isMobile) {
        if (this.isPlpExclusive) {
          return this.showHoverImage && this.transitionImage
        }
        return (this.isPlpExclusive || !this.isWornImage) && this.transitionImage
      } else {
        return (
          (this.isFirstTransitionInViewport || this.isFirstShow) &&
          (this.isPlpExclusive || !this.isWornImage) &&
          this.transitionImage
        )
      }
    },
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    slidesPerView() {
      return this.isMobile ? 1.5 : 2.5
    },
    swiperConfig() {
      return {
        slidesPerView: this.isPlpExclusive ? this.slidesPerView : 1,
        allowTouchMove: this.isMobile && this.variants?.length > 1,
        loop: false,
        touchStartPreventDefault: false,
        grabCursor: false,
      }
    },
  },
  watch: {
    isFirstTransitionInViewport(nValue) {
      if (nValue && !this.isFirstShow) {
        this.isFirstShow = true
      }
    },
  },
  methods: {
    goToSwipe(dir) {
      if (this.isPlpExclusive) {
        if (dir === 'next') {
          this.$refs.swiper?.swiper?.slideTo(this.variants.length + 1)
        }
        if (dir === 'prev') {
          this.$refs.swiper?.swiper?.slideTo(1)
        }
      }
    },
    imageLoaded() {
      this.transitionLoaded = true
    },
    changeVariant(index) {
      this.$emit('update:change-variant', index)
    },
    setImpolicy(url) {
      if (this.isWornImage) {
        return url
      }
      return Images.getClusterTileImage({
        mediaQuery: this.$mq,
        productImage: url,
        productType: this.category,
      })
    },
  },
}
